"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Dropdown = _interopRequireDefault(require("./Dropdown"));
var _excluded = ["value", "onChange", "options", "styleKey", "children", "tooltip", "direction", "defaultValue"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var List = function List(_ref) {
  var options = _ref.options,
    onChange = _ref.onChange,
    value = _ref.value,
    onClose = _ref.onClose,
    styleKey = _ref.styleKey;
  var _useState = (0, _react.useState)(function () {
      var index = options.findIndex(function (item) {
        return item.value === value;
      });
      return ~index ? index : 0;
    }),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    tabIndex = _useState2[0],
    setTabIndex = _useState2[1];
  var optionsRef = (0, _react.useRef)([]);
  var focusedRef = (0, _react.useRef)(false);
  (0, _react.useEffect)(function () {
    optionsRef.current[tabIndex].focus();
  }, [tabIndex]);
  var handleKeyDown = function handleKeyDown(e) {
    if (!focusedRef.current) return;
    e.stopPropagation();
    switch (e.key) {
      case 'ArrowUp':
        return setTabIndex(function (index) {
          return Math.max(index - 1, 0);
        });
      case 'ArrowDown':
        return setTabIndex(function (index) {
          return Math.min(index + 1, options.length - 1);
        });
      default:
        return;
    }
  };
  var handleFocus = function handleFocus() {
    focusedRef.current = true;
  };
  var handleBlur = function handleBlur() {
    focusedRef.current = false;
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-1",
    onFocus: handleFocus,
    onBlur: handleBlur,
    onKeyDown: handleKeyDown
  }, options.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("button", {
      ref: function ref(node) {
        return optionsRef.current[index] = node;
      },
      tabIndex: tabIndex === index ? '0' : '-1',
      key: item.label,
      className: (0, _classnames["default"])('block text-left w-full px-4 py-2 text-gray-medium focus:bg-secondary hover:bg-secondary whitespace-no-wrap', {
        'bg-secondary': item.value === value,
        'text-primary': item.value === value
      }),
      onClick: function onClick(e) {
        e.preventDefault();
        onChange(item.value);
        onClose();
      },
      style: styleKey ? (0, _defineProperty2["default"])({}, styleKey, item.value) : {}
    }, item.label);
  }));
};
function DropdownList(_ref3, ref) {
  var value = _ref3.value,
    onChange = _ref3.onChange,
    options = _ref3.options,
    styleKey = _ref3.styleKey,
    children = _ref3.children,
    tooltip = _ref3.tooltip,
    _ref3$direction = _ref3.direction,
    direction = _ref3$direction === void 0 ? 'up' : _ref3$direction,
    defaultValue = _ref3.defaultValue,
    rest = (0, _objectWithoutProperties2["default"])(_ref3, _excluded);
  var target = options.find(function (item) {
    return item.value === value;
  });
  return /*#__PURE__*/_react["default"].createElement(_Dropdown["default"], (0, _extends2["default"])({}, rest, {
    ref: ref,
    direction: direction,
    tooltip: tooltip,
    className: (0, _classnames["default"])({
      'bg-secondary': value !== defaultValue,
      'text-primary': value !== defaultValue
    }),
    overlay: function overlay(_ref4) {
      var onClose = _ref4.onClose;
      return /*#__PURE__*/_react["default"].createElement(List, {
        options: options,
        value: value,
        styleKey: styleKey,
        onChange: onChange,
        onClose: onClose
      });
    },
    style: styleKey ? (0, _defineProperty2["default"])({}, styleKey, value) : {}
  }), children ? children : target ? target.label : '');
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.forwardRef)(DropdownList);
//# sourceMappingURL=DropdownList.js.map